import React from "react";
/* Topbar — Phase B primitive.
   Sticky bar at the top of the content area. Three slots: left / center / right.

   Props:
     left:    ReactNode — page title / breadcrumb
     center:  ReactNode — global controls (range, scenario, value-mode)
     right:   ReactNode — utility actions (refresh, bell, edit, settings, lang)
*/

export default function Topbar({ left, center, right, className = "", ...rest }) {
  return (
    <header
      className={`v2-topbar ${className}`.trim()}
      role="banner"
      {...rest}
    >
      {left != null ? <div className="v2-topbar__left">{left}</div> : null}
      {center != null ? <div className="v2-topbar__center">{center}</div> : null}
      {right != null ? <div className="v2-topbar__right">{right}</div> : null}
    </header>
  );
}
